import React from "react";
import logo from "../assets/img/HomePage/humqadamLogo.svg";
import shirkat from "../assets/img/HomePage/shirkatGahLogo.svg";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main,
  },
}));

const Header = ({ main: _main }) => {
  const classes = useStyles();

  return (
    <div>
      <nav className="bg-white border-gray-200 bg-color">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-3 sm:p-4 gap-2">
          {/* Left logo - links to home */}
          <a
            href="/"
            className="flex items-center cursor-pointer shrink-0"
          >
            <img src={logo} className="h-9 sm:h-10 md:h-12 mr-2 sm:mr-3 max-h-12" alt="HumQadam Logo" />
          </a>
          
          {/* Right side - ShirkatGah logo and Back link */}
          <div className="flex items-center md:order-2 shrink-0">
            <a href="https://shirkatgah.org/" target="_blank" rel="noreferrer" className="flex items-center">
              <img src={shirkat} className="h-9 sm:h-10 md:h-12 mr-2 sm:mr-3 max-h-12" alt="ShirkatGah Logo" />
            </a>
          </div>
          
          {/* Back to ShirkatGah homepage link - always visible */}
          <div className="items-center justify-between w-full md:flex md:w-auto md:order-1">
            <ul className="flex flex-col font-medium p-2 md:p-0 mt-2 md:mt-0 rounded-lg md:flex-row md:space-x-8 md:border-0">
              <li>
                <a
                  href="https://shirkatgah.org/"
                  target="_blank"
                  className={`block py-2 pl-3 pr-4 text-sm sm:text-base ${classes.textColor}`}
                  rel="noreferrer"
                >
                  Back to ShirkatGah homepage
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
